import * as React from 'react'

import { StyledMain } from './styles'

export interface CustomHeaderProps {
  withSiderRight?: boolean
  children?: React.ReactNode
  isFixedWidth?: boolean
}

const Main = ({ withSiderRight = false, children, isFixedWidth }: CustomHeaderProps) => {
  return (
    <StyledMain id="nova-shared-Main-root" className={withSiderRight ? 'with-sider-right' : ''}>
      <div className={`main ${isFixedWidth ? 'fixedWidth' : ''}`}> {children}</div>
    </StyledMain>
  )
}

export default Main
